import React from 'react';
import './../index.css';

const ProjectLayout = ({ children, className = '' }) => {
  const baseClasses = 'flex flex-col-reverse lg:flex-row lg:items-stretch';
  const combinedClasses = [baseClasses, className].filter(Boolean).join(' ');

  return (
    <div className={combinedClasses}>
      <div className="grid w-full grid-cols-1 gap-5 lg:grid-cols-2">
        {children}
      </div>
    </div>
  );
};

export default ProjectLayout;
